import { tracked } from '@glimmer/tracking';

import FilterSortGoalMy from 'webapp/models-custom/filter-sort/goal-my';

export default class FilterSortGoalMyInGrid extends FilterSortGoalMy {
	@tracked override viewId = 'grid';
	override itemDomSelector = 'li.filter-sort-item';
}
